import { ClientUserDTO } from 'interfaces';

export const parseClientToCompanyInfoString = (client: ClientUserDTO) => {
   const { companyName, address, zipCode, city } = client;
   return `${companyName}, ${address}, ${zipCode} ${city}`;
};
